module.exports = __webpack_public_path__ + "ad07d48b3fe96b43da83c46fe42e0ff4.png";